/* tslint:disable */
/* eslint-disable */
export enum ImportedStatisticsLineResultErrorType {
  Error = 0,
  Warning = 1
}
